export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_11.0ed680ef.jpg";